import lodash from 'lodash';
import {i18n} from "../../../vue-i18n";

export default class AddPaymentParameters {
  constructor(newPaymentParameters) {
    this.commandName = "AddPaymentParameters";
    this.newPaymentParameters = newPaymentParameters;
    this.description =
      `${newPaymentParameters.startDateDay}.${newPaymentParameters.startDateMonth}.${newPaymentParameters.startDateYear} - ${newPaymentParameters.endDateDay}.${newPaymentParameters.endDateMonth}.${newPaymentParameters.endDateYear} ${i18n.t('CONTENT.events.with_rate')} ${newPaymentParameters.leaseRate} ${newPaymentParameters.currencyCode}`;
  }

  // Use this method to push this command to the server
  serialize() {
    const uuidv4 = require('uuid/v4');
    if (!this.newPaymentParameters.id) { this.newPaymentParameters.id = uuidv4(); }

    const clone = lodash.clone(this.newPaymentParameters);

    const serialisedCommand = JSON.stringify(clone);

    return {
      commandName: this.commandName,
      serialisedCommand: serialisedCommand
    }
  }

  equal() {
    // will always return false so user can add multiple payments
    return false;
  }
}
